import React, { useRef, useEffect, useCallback } from 'react';
import type { CampaignCard as CampaignCardStyles } from '../../CampaignCard/css/CampaignCard.modules';
import { CampaignCollapsibleControls } from '../../../shared/CampaignCollapsibleControls';
import campaignsCarouselStyles from '../css/CampaignsCarousel.module.css';

interface CarouselControlsProps {
  arrow: string;
  isCollapsed: boolean;
  onArrowClick: () => void;
  hasMany: boolean;
  campaignCardStyles: CampaignCardStyles;
}

const CarouselControls: React.FC<CarouselControlsProps> = ({
  arrow,
  isCollapsed,
  onArrowClick,
  hasMany,
  campaignCardStyles
}) => {
  const glowBoxRef = useRef<HTMLDivElement>(null);
  const prevCollapsedRef = useRef(isCollapsed);

  useEffect(() => {
    if (prevCollapsedRef.current === isCollapsed) return;
    prevCollapsedRef.current = isCollapsed;

    const el = glowBoxRef.current;
    if (!el) return;

    if (!isCollapsed) {
      el.setAttribute('data-stretch', 'true');
    }
  }, [isCollapsed]);

  const handleAnimationEnd = useCallback(() => {
    glowBoxRef.current?.removeAttribute('data-stretch');
  }, []);

  return (
    <div
      ref={glowBoxRef}
      className={campaignsCarouselStyles.glowBox}
      data-has-many={hasMany}
      data-collapsed={isCollapsed}
      onAnimationEnd={handleAnimationEnd}
    >
      <CampaignCollapsibleControls
        arrow={arrow}
        isCollapsed={isCollapsed}
        onArrowClick={onArrowClick}
        hasMany={hasMany}
        swipeBlockClassName={campaignCardStyles.swipeBlock}
        arrowClassName={campaignCardStyles.arrow}
        arrowRotatedClassName={campaignCardStyles.rotated}
      />
    </div>
  );
};

export default CarouselControls;
